export enum SIGNEE_STATUS {
  INVITATION_SENT = 'invitation_sent',
  INVITATION_PENDING = 'invitation_pending',
  READY_FOR_SIGNATURE = 'ready_for_signature',
  SUCCESSFULLY_SIGNED = 'successfully_signed',
  UNDER_REVIEW = 'under_review',
  CANCELLED = 'cancelled',
}
